import { TranslocoService } from '@jsverse/transloco';
import { Component, inject } from '@angular/core';
import { KpiWidgetComponent } from '../../../../../../_shared/components/kpi-widget/kpi-widget.component';
import { BaseWidgetComponent } from '../../../../../../home/home-widgets/widgets/base-widget.component';
import { FilterService } from '../../../../../../_shared/services';
import { AccountFilterRequest } from '../../../../../../_shared/models/account-filter.model';
import { ServiceLibraryService } from '../../../services/service-library.service';
import { ErrorHandlerService } from '../../../../../../_shared/services/error-handler.service';

@Component({
  selector: 'app-connected-service-libraries',
  standalone: true,
  imports: [KpiWidgetComponent],
  templateUrl: './connected-service-libraries.component.html',
  styleUrl: './connected-service-libraries.component.scss'
})
export class ConnectedServiceLibrariesComponent extends BaseWidgetComponent {
  private readonly transloco = inject(TranslocoService);
  private serviceLibraryService: ServiceLibraryService = inject(ServiceLibraryService);
  private errorHandlerService = inject(ErrorHandlerService);
  
  hasError: boolean = false;
  errorMessage: string = '';

  constructor() {
    const filterService: FilterService = inject(FilterService);
    super(filterService);
    this.title = this.transloco.translate('serviceLibrary.widgets.connectedLibraries');
    this.isLoading = true;
    this.value = 0;
  }

  protected override async onFilterChangeAsync(): Promise<void> {
    await this.getConnectedServiceLibraryKpiStats();
  }

  public override formatValue(value: number): string {
    return `${value}`;
  }

  async getConnectedServiceLibraryKpiStats() {
    try {
      this.isLoading = true;
      this.cancelSubject.next();
      const request: AccountFilterRequest = {
        accountIds: this.widgetFilter.accountIds
      }

      const response = await this.serviceLibraryService.getConnectedServiceLibraryStatsKpi(request, this.cancelSubject);
      this.value = response.data ?? 0;
    } catch(error) {
      this.errorHandlerService.handleError(error, {
				callback: (message) => {
					this.errorMessage = message;
					this.hasError = true;
					this.isLoading = false;
				}
			});
    } finally {
      this.isLoading = false;
    }
  }
}